import {
  combineReducers,
  configureStore,
  createAction,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { globalFilterListenerMiddleware } from './middlewares/globalFilters';

import apiSlice from '@/api/apiSlice';
import { authReducer } from '@/features/auth';
import { StarvationBidderReducer } from '@/features/starvationBidder';
import { userReducer } from '@/features/users';

export const resetStore = createAction('store/reset');

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  user: userReducer,
  starvationBidder: StarvationBidderReducer,
});

const resettableRootReducer: typeof rootReducer = (state, action) => {
  if (resetStore.match(action)) {
    return rootReducer(undefined, action);
  }

  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(globalFilterListenerMiddleware.middleware)
      .concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
